var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"oxy-indicator-lights",on:{"click":function($event){$event.stopPropagation();return _vm.resetControl.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }